export default "__VITE_ASSET__BEKnItnC__"